import { computed } from 'vue';
import { toValue } from '@vueuse/core';
import {
    getFeatureExhaustion,
    getFeatureExclude,
    getFeatureScope,
    getFeatureUnit,
    getFeatureUsed,
    getFeatureValue,
    getFeatureCount,
    getFeatureFormat,
    getFeatureLimit,
    getFeatureLimitUsed,
} from '@/components/payments/components/service-plan/components/features/utils.js';

export default function useFeature(feature, params = {}) {
    return {
        value: computed(() => getFeatureValue(feature.value)),
        limit: computed(() => getFeatureLimit(feature.value)),
        limitUsed: computed(() => getFeatureLimitUsed(feature.value)),
        scope: computed(() => getFeatureScope(feature.value)),
        used: computed(() => getFeatureUsed(feature.value)),
        exclude: computed(() => getFeatureExclude(feature.value)),
        unit: computed(() => getFeatureUnit(feature.value)),
        count: computed(() => getFeatureCount(feature.value)),
        format: computed(() => getFeatureFormat(feature.value)),
        exhaustion: computed(() => getFeatureExhaustion(feature.value, toValue(params))),
    };
}
